webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(__webpack_require__(75));
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_TOUCH_DEVICE = exports.SET_TOUCH_DEVICE = 'SET_TOUCH_DEVICE';
	var SET_MOUSE_POSITION = exports.SET_MOUSE_POSITION = 'SET_MOUSE_POSITION';
	var SET_MOUSE_IN_WINDOW = exports.SET_MOUSE_IN_WINDOW = 'SET_MOUSE_IN_WINDOW';
	var SET_CLIENT_DIMENSIONS = exports.SET_CLIENT_DIMENSIONS = 'SET_CLIENT_DIMENSIONS';
	var SET_TIMER = exports.SET_TIMER = 'SET_TIMER';
	var SET_ABOUT_DISPLAY = exports.SET_ABOUT_DISPLAY = 'SET_ABOUT_DISPLAY';
	var SET_LOADED = exports.SET_LOADED = 'SET_LOADED';
	
	var ADD_PROJECT = exports.ADD_PROJECT = 'ADD_PROJECT';
	var SET_INDEX = exports.SET_INDEX = 'SET_INDEX';
	var SET_NEXT_INDEX = exports.SET_NEXT_INDEX = 'SET_NEXT_INDEX';
	var SET_PREV_INDEX = exports.SET_PREV_INDEX = 'SET_PREV_INDEX';
	var SET_TOGGLE_HOVER = exports.SET_TOGGLE_HOVER = 'SET_TOGGLE_HOVER';
	var SET_DIRECTION = exports.SET_DIRECTION = 'SET_DIRECTION';
	var SET_REQUEST_NEXT_SLIDE = exports.SET_REQUEST_NEXT_SLIDE = 'SET_REQUEST_NEXT_SLIDE';

/***/ },
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _App = __webpack_require__(25);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Slider = __webpack_require__(26);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    App: _App2.default,
	    Slider: _Slider2.default
	  }
	});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _MutationsTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_MutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  touchDevice: false,
	  mousePosition: {
	    x: null,
	    y: null
	  },
	  mouseInWindow: true,
	  clientDimensions: {
	    width: 0,
	    height: 0,
	    hoverZone: 0
	  },
	  timer: 0,
	  timerMax: 5000,
	  aboutDisplay: false,
	  loaded: false
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_TOUCH_DEVICE, function (state, value) {
	  state.touchDevice = value;
	}), (0, _defineProperty3.default)(_mutations, types.SET_MOUSE_POSITION, function (state, mousePosition) {
	  state.mousePosition = mousePosition;
	}), (0, _defineProperty3.default)(_mutations, types.SET_MOUSE_IN_WINDOW, function (state, mouseInWindow) {
	  state.mouseInWindow = mouseInWindow;
	}), (0, _defineProperty3.default)(_mutations, types.SET_CLIENT_DIMENSIONS, function (state, clientDimensions) {
	  state.clientDimensions = clientDimensions;
	}), (0, _defineProperty3.default)(_mutations, types.SET_TIMER, function (state, value) {
	  state.timer = value;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ABOUT_DISPLAY, function (state, value) {
	  state.aboutDisplay = value;
	}), (0, _defineProperty3.default)(_mutations, types.SET_LOADED, function (state, value) {
	  state.loaded = value;
	}), _mutations);
	
	var getters = {
	  touchDevice: function touchDevice(state) {
	    return state.touchDevice;
	  },
	  mousePosition: function mousePosition(state) {
	    return state.mousePosition;
	  },
	  mouseInWindow: function mouseInWindow(state) {
	    return state.mouseInWindow;
	  },
	  clientDimensions: function clientDimensions(state) {
	    return state.clientDimensions;
	  },
	  timer: function timer(state) {
	    return state.timer;
	  },
	  timerMax: function timerMax(state) {
	    return state.timerMax;
	  },
	  aboutDisplay: function aboutDisplay(state) {
	    return state.aboutDisplay;
	  },
	  loaded: function loaded(state) {
	    return state.loaded;
	  }
	};
	
	var actions = {
	  setTouchDevice: function setTouchDevice(_ref, value) {
	    var commit = _ref.commit;
	
	    commit([types.SET_TOUCH_DEVICE], value);
	  },
	  setMousePosition: function setMousePosition(_ref2, mousePosition) {
	    var commit = _ref2.commit;
	
	    commit([types.SET_MOUSE_POSITION], mousePosition);
	  },
	  setMouseInWindow: function setMouseInWindow(_ref3, mouseInWindow) {
	    var commit = _ref3.commit;
	
	    commit([types.SET_MOUSE_IN_WINDOW], mouseInWindow);
	  },
	  setClientDimensions: function setClientDimensions(_ref4, clientDimensions) {
	    var commit = _ref4.commit;
	
	    commit([types.SET_CLIENT_DIMENSIONS], clientDimensions);
	  },
	  setTimer: function setTimer(_ref5, value) {
	    var commit = _ref5.commit;
	
	    commit([types.SET_TIMER], value);
	  },
	  setAboutDisplay: function setAboutDisplay(_ref6, value) {
	    var commit = _ref6.commit;
	
	    commit([types.SET_ABOUT_DISPLAY], value);
	  },
	  setLoaded: function setLoaded(_ref7, value) {
	    var commit = _ref7.commit;
	
	    commit([types.SET_LOADED], value);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _MutationsTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_MutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  projects: [{
	    'key': 0,
	    'id': 'domingo',
	    'link': 'https://domingo.tv',
	    'thumbnail': 'static/img/projects/domingo.jpg',
	    'title': 'DominGo',
	    'shortTitle': 'DominGo',
	    'client': 'Streamer - Youtuber',
	    'type': 'Freelance Project',
	    'role': 'Project Manager / UI-UX Designer / Developer',
	    'stack': 'React / Redux / KoaJS / Node',
	    'more': ['audience', '+1.200M monthly viewed pages']
	  }, {
	    'key': 1,
	    'id': 'voices',
	    'link': 'https://voices.gg',
	    'thumbnail': 'static/img/projects/voices.jpg',
	    'title': 'Voices',
	    'shortTitle': 'Voices',
	    'client': 'Game web app',
	    'type': 'Freelance Project',
	    'role': 'Project Manager / UI-UX Designer',
	    'stack': 'VueJS / VueX / Node / Sockets',
	    'more': ['audience', '+1.000M viewed pages first month']
	  }, {
	    'key': 2,
	    'id': 'lifeRide',
	    'link': 'https://www.liferidebyhotelf1.com/',
	    'thumbnail': 'static/img/projects/life-ride.jpg',
	    'title': 'Life Ride',
	    'shortTitle': 'Life Ride',
	    'client': 'Hotel F1',
	    'type': 'Internship',
	    'role': 'Front-End Developer',
	    'stack': 'ES6 / Canvas',
	    'more': ['agency', 'anonymous']
	  }, {
	    'key': 3,
	    'id': 'gotaga',
	    'link': 'http://gotaga.tv',
	    'thumbnail': 'static/img/projects/gotaga.jpg',
	    'title': 'Gotaga',
	    'shortTitle': 'Gotaga',
	    'client': 'Streamer - Youtuber',
	    'type': 'Freelance project',
	    'role': 'Full-Stack Developer / UI-UX Designer',
	    'stack': 'AngularJS / Wordpress / WP Rest API',
	    'more': ['audience', '+700k monthly viewed pages']
	  }, {
	    'key': 4,
	    'id': 'zerator',
	    'link': 'http://zerator.com',
	    'thumbnail': 'static/img/projects/zerator.jpg',
	    'title': 'Zerator',
	    'shortTitle': 'Zerator',
	    'client': 'Streamer - Youtuber',
	    'type': 'Freelance project',
	    'role': 'Full-Stack Developer / UI-UX Designer',
	    'stack': 'AngularJS / Wordpress / WP Rest API',
	    'more': ['audience', '+600k monthly viewed pages']
	  }, {
	    'key': 5,
	    'id': 'serreChevalier',
	    'link': 'http://www.serre-chevalier.com/',
	    'thumbnail': 'static/img/projects/serre-chevalier.jpg',
	    'title': 'Serre-Chevalier',
	    'shortTitle': 'Serre-Che',
	    'client': 'Tourist Office / Ski station',
	    'type': 'Freelance project',
	    'role': 'Lead Front-End Developer',
	    'stack': 'Wordpress / SITRA2 API / Custom plugins',
	    'more': ['agency', 'mezcalito']
	  }],
	  currentIndex: 0,
	  nextIndex: null,
	  prevIndex: null,
	  toggleHover: false,
	  direction: null,
	  requestNextSlide: null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_INDEX, function (state, index) {
	  state.currentIndex = index;
	}), (0, _defineProperty3.default)(_mutations, types.SET_NEXT_INDEX, function (state, nextIndex) {
	  state.nextIndex = nextIndex;
	}), (0, _defineProperty3.default)(_mutations, types.SET_PREV_INDEX, function (state, prevIndex) {
	  state.prevIndex = prevIndex;
	}), (0, _defineProperty3.default)(_mutations, types.SET_TOGGLE_HOVER, function (state, toggleHover) {
	  state.toggleHover = toggleHover;
	}), (0, _defineProperty3.default)(_mutations, types.SET_DIRECTION, function (state, direction) {
	  state.direction = direction;
	}), (0, _defineProperty3.default)(_mutations, types.SET_REQUEST_NEXT_SLIDE, function (state, value) {
	  state.requestNextSlide = value;
	}), _mutations);
	
	var getters = {
	  projects: function projects(state) {
	    return state.projects;
	  },
	  currentIndex: function currentIndex(state) {
	    return state.currentIndex;
	  },
	  nextIndex: function nextIndex(state) {
	    return state.nextIndex;
	  },
	  prevIndex: function prevIndex(state) {
	    return state.prevIndex;
	  },
	  toggleHover: function toggleHover(state) {
	    return state.toggleHover;
	  },
	  direction: function direction(state) {
	    return state.direction;
	  },
	  requestNextSlide: function requestNextSlide(state) {
	    return state.requestNextSlide;
	  }
	};
	
	var actions = {
	  setCurrentIndex: function setCurrentIndex(_ref, index) {
	    var commit = _ref.commit;
	
	    if (index > state.projects.length - 1) {
	      index = 0;
	    } else if (index < 0) {
	      index = state.projects.length - 1;
	    }
	    commit([types.SET_INDEX], index);
	  },
	  setNextIndex: function setNextIndex(_ref2, nextIndex) {
	    var commit = _ref2.commit;
	
	    if (nextIndex > state.projects.length - 1) {
	      nextIndex = 0;
	    }
	
	    commit([types.SET_NEXT_INDEX], nextIndex);
	  },
	  setPrevIndex: function setPrevIndex(_ref3, prevIndex) {
	    var commit = _ref3.commit;
	
	    if (prevIndex < 0) {
	      prevIndex = state.projects.length - 1;
	    }
	
	    commit([types.SET_PREV_INDEX], prevIndex);
	  },
	  setToggleHover: function setToggleHover(_ref4, toggleHover) {
	    var commit = _ref4.commit;
	
	    commit([types.SET_TOGGLE_HOVER], toggleHover);
	  },
	  setDirection: function setDirection(_ref5, direction) {
	    var commit = _ref5.commit;
	
	    commit([types.SET_DIRECTION], direction);
	  },
	  setRequestNextSlide: function setRequestNextSlide(_ref6, value) {
	    var commit = _ref6.commit;
	
	    commit([types.SET_REQUEST_NEXT_SLIDE], value);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Store = __webpack_require__(24);
	
	var _Store2 = _interopRequireDefault(_Store);
	
	var _vuex = __webpack_require__(1);
	
	var _Loader = __webpack_require__(77);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Slider = __webpack_require__(79);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Timeline = __webpack_require__(83);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Navbar = __webpack_require__(78);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _About = __webpack_require__(76);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  store: _Store2.default,
	  components: {
	    Loader: _Loader2.default,
	    Slider: _Slider2.default,
	    Timeline: _Timeline2.default,
	    Navbar: _Navbar2.default,
	    About: _About2.default
	  },
	  data: function data() {
	    return {
	      slideInterval: null,
	      timerMax: 5000
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['touchDevice', 'mousePosition', 'clientDimensions', 'currentIndex', 'toggleHover', 'timer', 'aboutDisplay', 'loaded']), {
	    childDisplay: function childDisplay() {
	      if (this.toggleHover && !this.touchDevice) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    appStyle: function appStyle() {
	      return 'height: ' + this.clientDimensions.height + 'px';
	    }
	  }),
	  watch: {
	    currentIndex: function currentIndex() {
	      this.$store.dispatch('setTimer', 0);
	    },
	    toggleHover: function toggleHover() {
	      if (!this.touchDevice) {
	        if (this.toggleHover !== false) {
	          this.pauseTimer();
	        } else {
	          this.playTimer();
	        }
	      }
	    },
	    aboutDisplay: function aboutDisplay() {
	      if (this.aboutDisplay === true) {
	        this.pauseTimer();
	      } else {
	        this.playTimer();
	      }
	    },
	    loaded: function loaded() {
	      if (this.loaded === true) {
	        this.playTimer();
	      }
	    }
	  },
	  methods: {
	    onMouseMove: function onMouseMove(e) {
	      if (!this.aboutDisplay && !this.touchDevice) {
	        this.$store.dispatch('setMousePosition', { x: e.clientX, y: e.clientY });
	      }
	    },
	    onMouseLeave: function onMouseLeave() {
	      this.$store.dispatch('setMouseInWindow', false);
	    },
	    onMouseEnter: function onMouseEnter() {
	      this.$store.dispatch('setMouseInWindow', true);
	    },
	    onResize: function onResize() {
	      var width = window.innerWidth;
	      var height = window.innerHeight;
	      this.$store.dispatch('setClientDimensions', { width: width, height: height, hoverZone: width / 10 });
	    },
	    pauseTimer: function pauseTimer() {
	      clearInterval(this.slideInterval);
	    },
	    playTimer: function playTimer() {
	      var _this = this;
	
	      this.slideInterval = setInterval(function () {
	        _this.$store.dispatch('setTimer', _this.timer += 1);
	        if (_this.timer > _this.timerMax) {
	          _this.$store.dispatch('setRequestNextSlide', true);
	          _this.$store.dispatch('setTimer', 0);
	        }
	      }, 1);
	    },
	    isTouchDevice: function isTouchDevice() {
	      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  },
	  mounted: function mounted() {
	
	    if (this.isTouchDevice()) {
	      this.$store.dispatch('setTouchDevice', true);
	    } else {
	      this.$store.dispatch('setTouchDevice', false);
	    }
	  },
	  created: function created() {
	    this.onResize();
	
	    window.addEventListener('resize', this.onResize);
	    document.addEventListener('mouseleave', this.onMouseLeave);
	    document.addEventListener('mouseenter', this.onMouseEnter);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.onResize);
	    document.removeEventListener('mouseleave', this.onMouseLeave);
	    document.removeEventListener('mouseenter', this.onMouseEnter);
	  }
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _gsap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['touchDevice', 'clientDimensions', 'aboutDisplay']), {
	    displayedClass: function displayedClass() {
	      return {
	        's--displayed': this.aboutDisplay
	      };
	    }
	  }),
	  watch: {
	    aboutDisplay: function aboutDisplay() {
	      if (this.aboutDisplay === true) {
	        this.show();
	      } else {
	        this.hide();
	      }
	    }
	  },
	  methods: {
	    onKeyUp: function onKeyUp(e) {
	      if (!this.switchingSlides && !this.toggleHover) {
	        if (e.keyCode === 27) {
	          if (this.aboutDisplay === true) {
	            this.$store.dispatch('setAboutDisplay', false);
	          }
	        }
	      }
	    },
	    show: function show() {
	      this.setContentTweens();
	
	      if (this.clientDimensions.width < 501) {
	        var tlMobile = new _gsap.TimelineLite();
	
	        tlMobile.add(_gsap.TweenLite.to(this.$el, 0.35, {
	          scale: 1,
	          opacity: 1,
	          ease: _gsap.Power2.easeInOut
	        }), 'start');
	
	        tlMobile.add(_gsap.TweenLite.to(this.$p[0], 0.8, {
	          opacity: 1,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.3');
	
	        tlMobile.add(_gsap.TweenLite.to(this.$p[1], 0.8, {
	          opacity: 1,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.5');
	
	        tlMobile.add(_gsap.TweenLite.to(this.$span, 0.8, {
	          opacity: 1,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.7');
	
	        tlMobile.add(_gsap.TweenLite.to(this.$socials, 0.55, {
	          opacity: 1,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.9');
	      } else {
	        var tlDefault = new _gsap.TimelineLite();
	
	        tlDefault.add(_gsap.TweenLite.to(this.$el, 0.35, {
	          scale: 1,
	          opacity: 1,
	          ease: _gsap.Power2.easeInOut
	        }), 'start');
	
	        tlDefault.add(_gsap.TweenLite.to(this.$p[0], 0.8, {
	          width: '100%',
	          x: 0,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.3');
	
	        tlDefault.add(_gsap.TweenLite.to(this.$p[1], 0.8, {
	          width: '100%',
	          x: 0,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.5');
	
	        tlDefault.add(_gsap.TweenLite.to(this.$span, 0.8, {
	          width: '100%',
	          x: 0,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.7');
	
	        tlDefault.add(_gsap.TweenLite.to(this.$socials, 0.55, {
	          opacity: 1,
	          ease: _gsap.Power2.easeOut
	        }), 'start+=.9');
	      }
	    },
	    hide: function hide() {
	      _gsap.TweenLite.to(this.$el, 0.45, {
	        scale: 1.15,
	        opacity: 0,
	        ease: _gsap.Power2.easeInOut,
	        onComplete: this.setContentTweens()
	      });
	    },
	    setContentTweens: function setContentTweens() {
	      if (this.clientDimensions.width < 501) {
	        _gsap.TweenLite.set([this.$p, this.$span], {
	          opacity: 0
	        });
	      } else {
	        _gsap.TweenLite.set([this.$p, this.$span], {
	          width: '0%',
	          x: -2
	        });
	      }
	      _gsap.TweenLite.set(this.$socials, {
	        opacity: 0
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$p = this.$el.getElementsByTagName('p');
	    this.$span = this.$el.getElementsByTagName('span');
	    this.$socials = this.$el.querySelector('.c-about__content__socials');
	
	    this.setContentTweens();
	
	    _gsap.TweenLite.set(this.$el, {
	      scale: 1.15,
	      opacity: 0
	    });
	  },
	  created: function created() {
	    var _this = this;
	
	    window.addEventListener('keyup', function (e) {
	      return _this.onKeyUp(e);
	    });
	  }
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _assetsLoader = __webpack_require__(22);
	
	var _assetsLoader2 = _interopRequireDefault(_assetsLoader);
	
	var _gsap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      progress: 0
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loaded']), {
	    progressSerialized: function progressSerialized() {
	      return (this.progress * 100).toFixed() + '%';
	    }
	  }),
	  methods: {
	    hide: function hide() {
	      var _this = this;
	
	      _gsap.TweenLite.to(this.$el, 0.35, {
	        autoAlpha: 0,
	        ease: _gsap.Power2.easeInOut,
	        onComplete: function onComplete() {
	          _this.$store.dispatch('setLoaded', true);
	          _this.$destroy();
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    new _assetsLoader2.default({
	      assets: [{ url: 'static/img/projects/voices.jpg', type: 'jpg' }, { url: 'static/img/projects/domingo.jpg', type: 'jpg' }, { url: 'static/img/projects/life-ride.jpg', type: 'jpg' }, { url: 'static/img/projects/gotaga.jpg', type: 'jpg' }, { url: 'static/img/projects/zerator.jpg', type: 'jpg' }, { url: 'static/img/projects/serre-chevalier.jpg', type: 'jpg' }, { url: 'static/img/pp.png', type: 'png' }]
	    }).on('progress', function (progress) {
	      self.progress = progress;
	    }).on('complete', function (map) {
	      setTimeout(function () {
	        self.hide();
	      }, 250);
	    }).start();
	  }
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    display: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['direction', 'aboutDisplay', 'currentIndex', 'projects']), {
	    displayClose: function displayClose() {
	      return {
	        's--close--displayed': this.aboutDisplay === true
	      };
	    },
	    projectIndex: function projectIndex() {
	      return this.currentIndex + 1 + '/' + this.projects.length;
	    }
	  }),
	  methods: {
	    toggleAboutDisplay: function toggleAboutDisplay() {
	      if (this.aboutDisplay === true) {
	        this.$store.dispatch('setAboutDisplay', false);
	      } else {
	        this.$store.dispatch('setAboutDisplay', true);
	      }
	    }
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _SliderItem = __webpack_require__(80);
	
	var _SliderItem2 = _interopRequireDefault(_SliderItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SliderItem: _SliderItem2.default
	  },
	  data: function data() {
	    return {
	      switchingSlides: false,
	      nextProjectTitle: '',
	      prevProjectTitle: ''
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['projects', 'currentIndex', 'prevIndex', 'nextIndex', 'toggleHover', 'requestNextSlide', 'direction', 'mousePosition', 'mouseInWindow', 'clientDimensions'])),
	  watch: {
	    mouseInWindow: function mouseInWindow() {
	      if (this.toggleHover !== false && this.mouseInWindow === false) {
	        var direction = this.direction || null;
	        this.$store.dispatch('setToggleHover', false);
	        this.$store.dispatch('setDirection', direction);
	      }
	    },
	    mousePosition: function mousePosition() {
	      this.watchMousePositon();
	    },
	    requestNextSlide: function requestNextSlide() {
	      if (this.requestNextSlide !== false) {
	        this.switchSlide('next');
	        this.$store.dispatch('setRequestNextSlide', false);
	      }
	    },
	    nextIndex: function nextIndex() {
	      this.nextProjectTitle = this.projects[this.nextIndex].shortTitle;
	    },
	    prevIndex: function prevIndex() {
	      this.prevProjectTitle = this.projects[this.prevIndex].shortTitle;
	    }
	  },
	  methods: {
	    watchMousePositon: function watchMousePositon() {
	      var hoverZone = this.clientDimensions.hoverZone;
	
	      if (this.toggleHover !== false && this.mousePosition.x > hoverZone && this.mousePosition.x < this.clientDimensions.width - hoverZone) {
	        this.$store.dispatch('setToggleHover', false);
	        this.$store.dispatch('setDirection', this.direction);
	      } else if (this.mouseInWindow) {
	        if (this.toggleHover === false && this.mousePosition.x < hoverZone) {
	          this.$store.dispatch('setToggleHover', true);
	          this.$store.dispatch('setDirection', 'prev');
	        } else if (this.toggleHover === false && this.mousePosition.x > this.clientDimensions.width - hoverZone) {
	          this.$store.dispatch('setToggleHover', true);
	          this.$store.dispatch('setDirection', 'next');
	        }
	      }
	    },
	    onKeyUp: function onKeyUp(e) {
	      if (!this.switchingSlides && !this.toggleHover) {
	        if (e.keyCode === 39) {
	          this.$store.dispatch('setDirection', 'next');
	          this.switchSlide('next');
	        }
	        if (e.keyCode === 37) {
	          this.$store.dispatch('setDirection', 'prev');
	          this.switchSlide('prev');
	        }
	      }
	    },
	    switchSlide: function switchSlide(requesuestedDirection) {
	      var direction = requesuestedDirection;
	
	      if (!this.switchingSlides) {
	        this.switchingSlides = true;
	
	        if (direction === 'next') {
	          this.$store.dispatch('setCurrentIndex', this.currentIndex + 1);
	        } else if (direction === 'prev') {
	          this.$store.dispatch('setCurrentIndex', this.currentIndex - 1);
	        }
	      } else {
	        console.warn('Can\'t translate ' + direction + ' slide at the moment');
	      }
	    },
	    rebindAllSlides: function rebindAllSlides() {
	      var _this = this;
	
	      this.$store.dispatch('setToggleHover', false);
	      this.switchingSlides = false;
	
	      this.$store.dispatch('setNextIndex', this.currentIndex + 1);
	      this.$store.dispatch('setPrevIndex', this.currentIndex - 1);
	
	      for (var i = 0; i < this.$children.length; i++) {
	        this.$children[i].reInitSlide();
	      }
	
	      setTimeout(function () {
	        _this.watchMousePositon();
	      }, 10);
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('setNextIndex', this.currentIndex + 1);
	    this.$store.dispatch('setPrevIndex', this.currentIndex - 1);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    window.addEventListener('keyup', function (e) {
	      return _this2.onKeyUp(e);
	    });
	  }
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _gsap = __webpack_require__(4);
	
	var _SliderItemInfos = __webpack_require__(82);
	
	var _SliderItemInfos2 = _interopRequireDefault(_SliderItemInfos);
	
	var _SliderItemBackground = __webpack_require__(81);
	
	var _SliderItemBackground2 = _interopRequireDefault(_SliderItemBackground);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SliderItemInfos: _SliderItemInfos2.default,
	    SliderItemBackground: _SliderItemBackground2.default
	  },
	  props: {
	    project: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      tempCurrentIndex: null,
	      requestedTranslate: {
	        init: null,
	        hover: null
	      },
	      currentTranslate: {
	        hover: null
	      },
	      currentlyTranslatingSlide: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['touchDevice', 'currentIndex', 'nextIndex', 'prevIndex', 'toggleHover', 'direction', 'requestedIndex']), {
	    slideCurrentIndex: function slideCurrentIndex() {
	      return this.tempCurrentIndex;
	    },
	    slideAdditionalClasses: function slideAdditionalClasses() {
	      return {
	        's-current': this.tempCurrentIndex === this.project.key,
	        's-requested': this.nextIndex === this.project.key || this.prevIndex === this.project.key
	      };
	    }
	  }),
	  watch: {
	    nextIndex: function nextIndex() {
	      if (this.nextIndex === this.project.key) {
	        this.setSlidePosition('next');
	      }
	    },
	    prevIndex: function prevIndex() {
	      if (this.prevIndex === this.project.key) {
	        this.setSlidePosition('prev');
	      }
	    },
	    toggleHover: function toggleHover() {
	      if (!this.currentlyTranslatingSlide && !this.touchDevice) {
	        if (this.tempCurrentIndex === this.project.key) {
	          if (this.direction === 'next') {
	            this.currentTranslate.hover = '-5%';
	          } else if (this.direction === 'prev') {
	            this.currentTranslate.hover = '5%';
	          }
	        }
	
	        if (this.toggleHover !== false) {
	          if (this.direction === 'next' && this.nextIndex === this.project.key) {
	            this.requestedHoverIn();
	          } else if (this.direction === 'prev' && this.prevIndex === this.project.key) {
	            this.requestedHoverIn();
	          }
	
	          if (this.tempCurrentIndex === this.project.key) {
	            this.currentHoverIn();
	          }
	        } else {
	          if (this.direction === 'next' && this.nextIndex === this.project.key) {
	            this.requestedHoverOut();
	          } else if (this.direction === 'prev' && this.prevIndex === this.project.key) {
	            this.requestedHoverOut();
	          }
	
	          if (this.tempCurrentIndex === this.project.key) {
	            this.currentHoverOut();
	          }
	        }
	      }
	    },
	    currentIndex: function currentIndex() {
	      var _this = this;
	
	      if (!this.currentlyTranslatingSlide) {
	        this.currentlyTranslatingSlide = true;
	
	        if (this.project.key === this.currentIndex) {
	          this.slideIn(function () {
	            _this.$children[0].showText();
	          });
	        }
	        if (this.project.key === this.tempCurrentIndex) {
	          this.slideOut(function () {
	            _this.$parent.rebindAllSlides();
	          });
	        }
	      }
	    }
	  },
	  methods: {
	    reInitSlide: function reInitSlide() {
	      this.currentlyTranslatingSlide = false;
	
	      if (this.tempCurrentIndex !== this.project.id) {
	        this.clearOpcaityAndScale();
	      }
	
	      this.tempCurrentIndex = this.currentIndex;
	    },
	    setSlidePosition: function setSlidePosition(direction) {
	      if (direction === 'next') {
	        this.requestedTranslate.init = '100%';
	        this.requestedTranslate.hover = '90%';
	      } else if (direction === 'prev') {
	        this.requestedTranslate.init = '-100%';
	        this.requestedTranslate.hover = '-90%';
	      }
	
	      _gsap.TweenLite.set(this.$el, {
	        x: this.requestedTranslate.init
	      });
	    },
	    requestedHoverIn: function requestedHoverIn() {
	      _gsap.TweenLite.to(this.$el, 0.55, {
	        x: this.requestedTranslate.hover,
	        ease: _gsap.Power2.easeOut
	      });
	    },
	    requestedHoverOut: function requestedHoverOut() {
	      _gsap.TweenLite.to(this.$el, 0.65, {
	        x: this.requestedTranslate.init,
	        ease: _gsap.Power2.easeOut
	      });
	    },
	    currentHoverIn: function currentHoverIn() {
	      _gsap.TweenLite.to(this.$el, 0.55, {
	        x: this.currentTranslate.hover,
	
	        ease: _gsap.Power2.easeOut
	      });
	    },
	    currentHoverOut: function currentHoverOut() {
	      _gsap.TweenLite.to(this.$el, 0.65, {
	        x: '0%',
	        opacity: 1,
	        ease: _gsap.Power2.easeOut
	      });
	    },
	    slideIn: function slideIn(callback) {
	      _gsap.TweenLite.to(this.$el, 0.35, {
	        x: '0%',
	        ease: _gsap.Power2.easeInOut,
	        onComplete: callback
	      });
	    },
	    slideOut: function slideOut(callback) {
	      _gsap.TweenLite.to(this.$el, 0.55, {
	        ease: _gsap.Power2.easeOut,
	        onComplete: callback
	      });
	    },
	    clearOpcaityAndScale: function clearOpcaityAndScale() {
	      _gsap.TweenLite.set(this.$el, {
	        opacity: 1,
	        scale: 1
	      });
	    },
	    clearTranslate: function clearTranslate() {
	      _gsap.TweenLite.set(this.$el, {
	        x: '0%'
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.tempCurrentIndex = this.currentIndex;
	
	    if (this.nextIndex === this.project.key) {
	      this.setSlidePosition('next');
	    } else if (this.prevIndex === this.project.key) {
	      this.setSlidePosition('prev');
	    }
	  }
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    project: {
	      type: Object
	    },
	    tempCurrentIndex: {
	      type: Number
	    }
	  },
	  data: function data() {
	    return {
	      scaleValue: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentIndex', 'timer', 'timerMax']), {
	    scale: function scale() {
	      if (this.currentIndex === this.project.key) {
	        this.scaleValue = 1 + this.timer / this.timerMax / 6;
	        return 'scale(' + this.scaleValue + ')';
	      } else if (this.tempCurrentIndex === this.project.key) {
	        return 'scale(' + this.scaleValue + ')';
	      }
	    }
	  })
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _gsap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    project: {
	      type: Object
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['nextIndex', 'prevIndex'])),
	  watch: {
	    nextIndex: function nextIndex() {
	      if (this.nextIndex === this.project.key) {
	        this.setTextTweens();
	      }
	    },
	    prevIndex: function prevIndex() {
	      if (this.prevIndex === this.project.key) {
	        this.setTextTweens();
	      }
	    }
	  },
	  methods: {
	    setTextTweens: function setTextTweens() {
	      _gsap.TweenLite.set([this.$title, this.$subtitle], {
	        width: '0%',
	        x: -10
	      });
	      _gsap.TweenLite.set(this.$infos, {
	        opacity: 0
	      });
	    },
	    showText: function showText() {
	      var tl = new _gsap.TimelineLite();
	
	      tl.add(_gsap.TweenLite.to(this.$title, 0.45, {
	        width: '100%',
	        x: 0,
	        ease: _gsap.Power2.easeInOut
	      }));
	      tl.add(_gsap.TweenLite.to(this.$subtitle, 0.35, {
	        width: '100%',
	        x: 0,
	        ease: _gsap.Power2.easeInOut
	      }));
	      tl.add(_gsap.TweenLite.to(this.$infos, 0.45, {
	        opacity: 1,
	        ease: _gsap.Power2.easeIn
	      }));
	    }
	  },
	  mounted: function mounted() {
	    this.$title = this.$el.querySelector('h1');
	    this.$subtitle = this.$el.querySelector('h2');
	    this.$infos = this.$el.querySelector('.item__infos__sub');
	  }
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    progress: {
	      type: Number
	    },
	    display: {
	      type: Boolean
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['timer', 'timerMax']), {
	    scaleX: function scaleX() {
	      return 'transform : scaleX(' + this.timer / this.timerMax + ')';
	    },
	    displayClass: function displayClass() {
	      return {
	        's--hide': this.display === false
	      };
	    }
	  })
	};

/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 67 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 68 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 69 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 70 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 71 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 72 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 73 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 74 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(68)
	
	/* script */
	__vue_exports__ = __webpack_require__(27)
	
	/* template */
	var __vue_template__ = __webpack_require__(86)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(69)
	
	/* script */
	__vue_exports__ = __webpack_require__(28)
	
	/* template */
	var __vue_template__ = __webpack_require__(87)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(73)
	
	/* script */
	__vue_exports__ = __webpack_require__(29)
	
	/* template */
	var __vue_template__ = __webpack_require__(91)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(74)
	
	/* script */
	__vue_exports__ = __webpack_require__(30)
	
	/* template */
	var __vue_template__ = __webpack_require__(92)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(67)
	
	/* script */
	__vue_exports__ = __webpack_require__(31)
	
	/* template */
	var __vue_template__ = __webpack_require__(85)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(70)
	
	/* script */
	__vue_exports__ = __webpack_require__(32)
	
	/* template */
	var __vue_template__ = __webpack_require__(88)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(71)
	
	/* script */
	__vue_exports__ = __webpack_require__(33)
	
	/* template */
	var __vue_template__ = __webpack_require__(89)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(72)
	
	/* script */
	__vue_exports__ = __webpack_require__(34)
	
	/* template */
	var __vue_template__ = __webpack_require__(90)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(66)
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(84)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-timeline",
	    class: _vm.displayClass
	  }, [_c('div', {
	    staticClass: "c-timeline__progress",
	    style: (_vm.scaleX)
	  })])
	},staticRenderFns: []}

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "c-slider"
	  }, [_c('nav', {
	    staticClass: "c-slider__nav c-slider__nav--left",
	    class: {
	      's--hovered': _vm.toggleHover && _vm.direction === 'prev' && !_vm.switchingSlides, 's--hide': _vm.toggleHover && _vm.direction === 'next'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.switchSlide('prev')
	      }
	    }
	  }, [_c('div', [_c('p', [_vm._v("prev")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevProjectTitle))])])]), _vm._v(" "), _c('nav', {
	    staticClass: "c-slider__nav c-slider__nav--right",
	    class: {
	      's--hovered': _vm.toggleHover && _vm.direction === 'next' && !_vm.switchingSlides, 's--hide': _vm.toggleHover && _vm.direction === 'prev'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.switchSlide('next')
	      }
	    }
	  }, [_c('div', [_c('p', [_vm._v("next")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.nextProjectTitle))])])]), _vm._v(" "), _c('div', _vm._l((_vm.projects), function(project) {
	    return _c('slider-item', {
	      attrs: {
	        "project": project
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    style: (_vm.appStyle),
	    attrs: {
	      "id": "app"
	    },
	    on: {
	      "mousemove": _vm.onMouseMove
	    }
	  }, [_c('loader'), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('timeline', {
	    attrs: {
	      "display": _vm.childDisplay
	    }
	  }), _vm._v(" "), _c('about'), _vm._v(" "), _c('slider')], 1)
	},staticRenderFns: []}

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "c-about",
	    class: _vm.displayedClass
	  }, [_vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-about__content"
	  }, [_c('p', [_vm._v("\n        Hey ! I’m Théo Kleman, a 20 years old web developer based in Paris.\n        "), _c('br'), _vm._v("\n        Currently in fourth year "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.hetic.net/"
	    }
	  }, [_vm._v("@hetic")]), _vm._v(", I also work as a freelancer !\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "last"
	  }, [_vm._v("\n        I’ve worked for a few clients, for which I used lovely stacks composed of ReactJS, VueJS, AngularJS, Sass, Webpack & Gulp.\n        "), _c('br'), _vm._v("\n        I'm also familiar with ES6. I'm currently learning WebGL stuff. You can also download "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "./static/cv-theokleman.pdf"
	    }
	  }, [_vm._v("my resume")]), _vm._v(" !\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        If you have something you want to discuss, feel free to contact me :)\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "c-about__content__socials"
	  }, [_c('div', [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://twitter.com/Theo_KlMan"
	    }
	  }, [_vm._v("twitter")])]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://fr.linkedin.com/in/theokleman"
	    }
	  }, [_vm._v("linkedin")])]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://github.com/TheoKleman/"
	    }
	  }, [_vm._v("github")])]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://codepen.io/theElkman/"
	    }
	  }, [_vm._v("codepen")])]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": "mailto:theokleman.com"
	    }
	  }, [_vm._v("mail")])])])])
	}]}

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    key: _vm.project.key,
	    staticClass: "c-slider__item",
	    class: _vm.slideAdditionalClasses,
	    attrs: {
	      "id": _vm.project.id
	    }
	  }, [_c('slider-item-infos', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _c('slider-item-background', {
	    attrs: {
	      "tempCurrentIndex": _vm.slideCurrentIndex,
	      "project": _vm.project
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item__background"
	  }, [_c('div', {
	    staticClass: "item__background__image",
	    style: ({
	      backgroundImage: 'url(' + _vm.project.thumbnail + ')',
	      transform: _vm.scale
	    })
	  })])
	},staticRenderFns: []}

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item__infos"
	  }, [_c('a', {
	    staticClass: "item__infos__main",
	    attrs: {
	      "target": "_blank",
	      "href": _vm.project.link
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.project.client))])]), _vm._v(" "), _c('div', {
	    staticClass: "item__infos__sub"
	  }, [_c('div', [_c('h3', [_vm._v("[type]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.type))])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("[role]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.role))])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("[stack]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.stack))])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("[" + _vm._s(_vm.project.more[0]) + "]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.more[1]))])])])])
	},staticRenderFns: []}

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "c-loader"
	  }, [_c('p', [_vm._v("loading")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.progressSerialized))])])
	},staticRenderFns: []}

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "c-nav"
	  }, [_c('div', {
	    staticClass: "c-nav__left"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "c-nav__menu",
	    class: _vm.displayClose
	  }, [_c('div', {
	    staticClass: "c-nav__item s--about"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleAboutDisplay($event)
	      }
	    }
	  }, [_vm._v("about me")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "c-nav__item s--close"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleAboutDisplay($event)
	      }
	    }
	  }, [_vm._v("close")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "c-nav__right"
	  }, [_c('div', {
	    staticClass: "c-nav__index",
	    class: _vm.displayClose
	  }, _vm._l((_vm.projects), function(project) {
	    return _c('span', {
	      class: {
	        's--active': project.key === _vm.currentIndex
	      }
	    })
	  }))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-nav__logo"
	  }, [_c('h1', [_vm._v("Théo Kleman")]), _vm._v(" "), _c('span', [_vm._v("another developer")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-nav__item"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://twitter.com/Theo_KlMan"
	    }
	  }, [_vm._v("twitter")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-nav__item"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://fr.linkedin.com/in/theokleman"
	    }
	  }, [_vm._v("linkedin")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-nav__item"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://github.com/TheoKleman/"
	    }
	  }, [_vm._v("github")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-nav__item"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://codepen.io/theElkman/"
	    }
	  }, [_vm._v("codepen")])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.33659855730ad9f182bc.js